import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * Test/A11y Environment Configuration
 * Bypasses authentication for testing purposes
 */

// Mock MSAL Configuration for testing
export const msalConfigCorporate: Configuration = {
    auth: {
        clientId: 'test-client-id',
        authority: 'https://login.microsoftonline.com/test-tenant',
        redirectUri: 'http://localhost:3000/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                // Suppress logs in test mode
            },
        },
    },
};

// Empty scopes for testing
const testScopes: string[] = [];

// Function to get login request
export const getLoginRequest = (): RedirectRequest => {
    return { scopes: testScopes };
};

export const loginRequest: RedirectRequest = {
    scopes: testScopes,
};

// Flag to indicate test mode - bypasses authentication
export const isTestMode = true;

// Test-specific settings - use mock API server
export const apiConfig = {
    baseUrl: 'http://localhost:8086',
    timeout: 30000,
};

export const appConfig = {
    enableDebugMode: true,
    enableAnalytics: false,
    logLevel: LogLevel.Verbose,
    applicationInsightsConnectionString: '', // No telemetry in test mode
};
